import { useAppDispatch } from '../../store/hooks';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { createNotification } from '../../store/notifications/notification-slice';
import { Box, Button, Typography } from '@mui/material';
import { InputKit } from '../../components/UI';
import { useState } from 'react';
import { AuthService } from '../../Service/AuthService';

export interface IFormInput {
  name: string;
  lastName: string;
  email: string;
}

const RegisterRequest = () => {
  const [success, setSuccess] = useState(false);
  const appDispatch = useAppDispatch();
  const methods = useForm<IFormInput>();
  const { handleSubmit } = methods;
  const navigate = useNavigate();

  const registerUser = async (values: IFormInput) => {
    try {
      const response = await AuthService.requireSignUp({
        email: values.email,
        name: values.name,
        lastName: values.lastName,
      });

      setSuccess(true);

      appDispatch(
        createNotification({
          type: 'success',
          message:
            'We have successfully received your request and will be reaching out to you very soon.',
        })
      );
    } catch (error: any) {
      appDispatch(
        createNotification({
          type: 'error',
          message: 'Something went wrong, please try again',
        })
      );
    }
  };
  return (
    <FormProvider {...methods}>
      <Box
        sx={{
          maxWidth: '100%',
          width: '100%',
          display: 'flex',
          padding: '20px',
          justifyContent: 'center',
          alignItems: 'center',
          '@media (max-width: 768px)': {
            alignItems: 'unset',
          },
        }}
      >
        <form
          style={{
            maxWidth: '472px',
            width: '100%',
          }}
        >
          <Box display={'flex'} flexDirection={'column'} gap={'24px'}>
            <Typography variant='h1'>
              Create your{' '}
              <span
                style={{
                  color: '#3293DB',
                }}
              >
                K2
              </span>{' '}
              account
            </Typography>
            {success ? (
              <>
                <Typography
                  sx={{
                    fontWeight: '500',
                    fontSize: '14px',
                    lineHeight: '17px',
                    color: '#736977',
                  }}
                >
                  We have successfully received your request and will be
                  reaching out to you very soon.
                </Typography>
                <Typography
                  sx={{
                    fontWeight: '500',
                    fontSize: '14px',
                    lineHeight: '17px',
                    color: '#736977',
                  }}
                >
                  Please keep an eye on your inbox for our follow-up email.
                </Typography>
                <Button
                  sx={{
                    background: '#3293DB',
                    color: '#fff',
                    width: '100%',
                    boxShadow: 'unset',
                    fontSize: '14px',
                    lineHeight: '17px',
                  }}
                  onClick={() => navigate('/')}
                  type='submit'
                  variant='contained'
                >
                  Return to Log in
                </Button>
              </>
            ) : (
              <>
                <Typography
                  sx={{
                    fontWeight: '500',
                    fontSize: '14px',
                    lineHeight: '17px',
                    color: '#736977',
                  }}
                >
                  Enter your details and we will be in touch with you shortly.
                </Typography>
                <Box display={'flex'} gap={'24px'}>
                  <InputKit
                    name={'name'}
                    placeholder={'First name'}
                    validation={{
                      required: {
                        value: true,
                        message: 'First name is required',
                      },
                      pattern: /^[A-Za-z]+$/i,
                    }}
                  />
                  <InputKit
                    name={'lastName'}
                    placeholder={'Last name'}
                    validation={{
                      required: {
                        value: true,
                        message: 'Last name is required',
                      },
                      pattern: /^[A-Za-z]+$/i,
                    }}
                  />
                </Box>
                <InputKit
                  name={'email'}
                  placeholder='Email'
                  // disabled={true}
                  type='email'
                  validation={{
                    required: {
                      value: true,
                      message: 'Email is required',
                    },
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: 'Invalid email address',
                    },
                  }}
                />
                <Button
                  sx={{
                    background: '#3293DB',
                    color: '#fff',
                    width: '100%',
                    boxShadow: 'unset',
                    fontSize: '14px',
                    lineHeight: '17px',
                  }}
                  onClick={handleSubmit(registerUser)}
                  type='submit'
                  variant='contained'
                >
                  Submit
                </Button>
                <Button
                  style={{
                    color: '#3293DB',
                    fontWeight: 500,
                  }}
                  variant='outlined'
                  onClick={() => navigate('/')}
                >
                  Return to Log in
                </Button>
              </>
            )}
          </Box>
        </form>
      </Box>
    </FormProvider>
  );
};

export default RegisterRequest;
